<template>
  <div>
    <Breadcrumbs title="Add record" main="Database"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <form @submit.prevent="createProduct">
              <div class="card-body">
                <div class="form-group">
                  <label>Date</label>
                  <input type="date" class="form-control" v-model="date">
                </div>

                <div class="form-group autocomplete">
                  <label>Competitor</label>
                  <vue-autosuggest
                      v-model="competitor"
                      :suggestions="filteredOptions"
                      @selected="onSelected"
                      :get-suggestion-value="getSuggestionValue"
                      :input-props="{id:'autosuggest__input', class:'form-control', placeholder:'Easy parts'}">
                    <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
                      <div>{{ suggestion.item }}</div>
                    </div>
                  </vue-autosuggest>
                </div>

                <div class="form-group">
                  <label>Part Number</label>
                  <input type="text" class="form-control" placeholder="559123041" v-model="part_number"
                         @change="getPartInfo">
                </div>

                <div class="form-group">
                  <label>Brand</label>
                  <input type="text" class="form-control" placeholder="BMW" v-model="brand">
                </div>

                <div class="form-group">
                  <label>Name</label>
                  <input type="text" class="form-control" placeholder="Led headlight" v-model="name">
                </div>

                <div class="form-group m-form__group">
                  <label>Price</label>
                  <div role="group" class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input type="number" placeholder="100.0" class="form-control" v-model="price">
                  </div>
                </div>
              </div>

              <div class="card-footer">
                <router-link
                    to="/research/database"
                    custom
                    v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                  <a :href="href" @click="navigate" class="btn btn-info mr-2">Cancel</a>
                </router-link>
                <button type="submit" class="btn btn-primary pull-right">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

.autosuggest__results ul {
  width: 100%;
  color: rgba(30, 39, 46, 1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
  border: 1px solid black;
  position: absolute;
  background-color: white;
}

.autosuggest__results li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}

.autosuggest__results li:hover {
  cursor: pointer;
}

.autosuggest__results {
  position: relative;
}

.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}

#autosuggest {
  width: 100%;
  display: block;
}

.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178, 0.2);
}
</style>

<script>
import {competitorProduct} from "../../../_services";
import {VueAutosuggest} from 'vue-autosuggest';

export default {
  data: function () {
    return {
      competitor: "",
      selected: "",
      suggestions: [],
      date: null,
      part_number: null,
      brand: null,
      name: null,
      price: null
    }
  },
  components: {
    VueAutosuggest
  },
  computed: {
    filteredOptions() {
      return [
        {
          data: this.suggestions.filter(option => {
            return option.toLowerCase().indexOf(this.competitor.toLowerCase()) > -1;
          })
        }
      ];
    }
  },
  created() {
    this.loadCompetitorList();
  },
  methods: {
    createProduct() {
      competitorProduct.addCompetitorProduct(
          this.date,
          this.part_number,
          this.brand,
          this.name,
          this.price,
          this.competitor
      )
          .then(
              async () => {
                const {dispatch} = this.$store;
                dispatch('alert/success', 'Product success added', {root: true});

                this.$router.push({
                  path: '/research/database'
                });
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    getPartInfo() {
      competitorProduct.getPartInfo(
          this.part_number
      )
          .then(
              async response => {
                this.brand = response.data.brand;
                this.name = response.data.name;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    onSelected(item) {
      this.selected = item.item;
      this.competitor = item.item;
    },
    getSuggestionValue(suggestion) {
      return suggestion.item;
    },
    loadCompetitorList() {
      competitorProduct.getCompetitorList()
          .then(
              async response => {
                this.suggestions = response.data.competitors;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    }
  }
}
</script>
